import { TabType } from ".";
import { ActiveIndicator, TabItem } from "./styles";
import { TabWrapper } from "./styles";

export interface TabProps {
  tab: TabType;
  setTab: (tab: TabType) => void;
}

const Tab = ({ tab, setTab }: TabProps) => {
  // 현재 활성 탭의 인덱스 계산
  const getActiveIndex = () => {
    switch (tab) {
      case TabType.PUB:
        return 0;
      case TabType.COMMUNITY:
        return 1;
      default:
        return 0;
    }
  };

  return (
    <TabWrapper>
      <TabItem
        isActive={tab === TabType.PUB}
        onClick={() => setTab(TabType.PUB)}
      >
        홀덤펍
      </TabItem>
      <TabItem
        isActive={tab === TabType.COMMUNITY}
        onClick={() => setTab(TabType.COMMUNITY)}
      >
        커뮤니티
      </TabItem>
      <ActiveIndicator activeIndex={getActiveIndex()} />
    </TabWrapper>
  );
};

export default Tab;
